import axios from "axios";
import { getStoredUser } from "./auth";
import { repairMojibakeDeep } from "./text";

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:5000";
const LANGUAGE_STORAGE_KEY = "learnova_language";

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json"
  }
});

api.interceptors.request.use((config) => {
  const nextConfig = { ...config };
  const selectedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY) === "en" ? "en" : "ar";
  const actorHeaders = {};
  const user = getStoredUser();

  if (user?.id) {
    actorHeaders["X-User-Id"] = String(user.id);
  }

  if (user?.role) {
    actorHeaders["X-User-Role"] = String(user.role);
  }

  nextConfig.headers = {
    ...(config.headers || {}),
    ...actorHeaders,
    "X-Language": selectedLanguage
  };

  return nextConfig;
});

api.interceptors.response.use(
  (response) => {
    if (response?.data) {
      response.data = repairMojibakeDeep(response.data);
    }
    return response;
  },
  (error) => {
    if (error?.response?.data) {
      error.response.data = repairMojibakeDeep(error.response.data);
    }
    return Promise.reject(error);
  }
);

export default api;
